<div class="container">
  <br>
  <div class="form-group">
    <label>{{question?.question_copy}}</label>
    <app-question-dropdown
      [showLabel]="false"
      [readOnly]="false"
      [options]="question"
      [selectedValue]="vap?.selectedOption"
      (questionAnswer)="selectChange($event)">
    </app-question-dropdown>
  </div>
  <div class="form-group">
    <input currencyMask
           type="tel"
           [options]="maskOptions"
           [(ngModel)]="vap.amount"
           [id]="question?.cent_aq_question_id"
           (ngModelChange)="onChange(0)"
           [class]="'form-control amount answers ' + question?.cent_aq_question_id"
           [placeholder]="'Limit ' + (currentVap?.value_min | currency:'ZAR':'R':'1.0-0') +
           ' - ' + (currentVap?.value_max | currency:'ZAR':'R':'1.0-0')">
  </div>
</div>
